<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_editar_descricao_filtro"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_editar_descricao_filtro"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">
              {{
                this.consultaAvancadaFiltro.id === 0
                  ? "Salvar Filtro"
                  : "Editar Filtro"
              }}
            </h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.$emit(`exibirModalEditarDescricaoFiltro`, false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-12 fv-row mb-4">
                <label :for="`descricaoFiltro`" class="form-label"
                  >Descrição</label
                >
                <input
                  :id="`descricaoFiltro`"
                  type="text"
                  class="form-control mb-2"
                  placeholder="Descrição do filtro"
                  maxlength="100"
                  v-model="this.consultaAvancadaFiltro.descricao"
                  v-on:keyup.enter="
                    nextFocus(`btnConfirmarEditarDescricaoFiltro`)
                  "
                />
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.$emit(`exibirModalEditarDescricaoFiltro`, false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarEditarDescricaoFiltro"
              @click="confirmarEditarDescricaoFiltro()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";

const consultaAvancadaInicializada = {
  id: 0,
  descricao: "",
  tabela: "",
  select: "",
  filter: "",
};

export default {
  emits: ["exibirModalEditarDescricaoFiltro", "confirmarEditarDescricaoFiltro"],
  props: {
    consultaAvancada: { type: Object, required: true },
  },
  methods: {
    async confirmarEditarDescricaoFiltro() {
      this.nextFocus("descricaoFiltro");
      var error = "";
      if (
        this.consultaAvancadaFiltro.descricao === "" ||
        this.consultaAvancadaFiltro.descricao === null
      ) {
        error = "A descrição não pode estar vazia!";
      }

      if (error != "") {
        await this.showInvalidAlert(error);
        this.nextFocus("descricaoFiltro");
      } else {
        this.$emit(
          "confirmarEditarDescricaoFiltro",
          this.consultaAvancadaFiltro
        );
        hideModal(this.$refs.kt_modal_editar_descricao_filtro);
        this.$emit("exibirModalEditarDescricaoFiltro", false);
      }
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    this.consultaAvancadaFiltro = JSON.parse(
      JSON.stringify(this.consultaAvancada)
    );
    setTimeout(() => {
      this.nextFocus("descricaoFiltro");
    }, 800);
  },
  data() {
    return {
      timeOut: null,
      consultaAvancadaFiltro: JSON.parse(
        JSON.stringify(consultaAvancadaInicializada)
      ),
    };
  },
};
</script>

<style></style>
